import { h, FunctionalComponent } from 'preact'
import { getParamFromUrl } from '../../utils/url'
import { QUERY_PARAMS } from '../../constants/query'
import Chat from '../Chat'
import s from './ChatLayout.css'

const ChatLayout: FunctionalComponent= () => {
  const activeChatLayoutId = getParamFromUrl(QUERY_PARAMS.CHAT)
  const chatId = Number(activeChatLayoutId)

  if (chatId) {
    return (
      <div className={s.ChatLayout}>
        <Chat chatId={chatId}/>
      </div>
    )
  }

  return (
    <div className={s.ChatLayout}>
      <div className={s.ChatLayout__empty}>
        Open Chat <br/>
        or create a new one
      </div>
    </div>
  )
}

export default ChatLayout
